import createSlice from "admin/store/create-slice";
import initialState from "admin/store/initial-state-schema";
import { getApiUrl } from 'shared-kernel/helpers';

const name = 'bulkedit';

const slice = createSlice({
    name,
    initialState,
    reducers: {
        requested: state => ({
            ...state,
            isFetching: true
        }),
        failed: state => ({
            ...state,
            isFetching: false,
            isFailed: true
        }),
        itemsReceived: (state, payload) => ({
            ...state,
            isFetching: false,
            items: payload.data.items,
            total: payload.data.total
        }),
        submitReceived: state => ({
            ...state,
            isFetching: false
        }),
        deleteReceived: state => ({
            ...state,
            isFetching: false
        }),
        addProductsToBrandReceived: state => ({
            ...state,
            isFetching: false
        }),
        changeByPercentageReceived: state => ({
            ...state,
            isFetching: false
        })
    }
});

const { requested, failed, itemsReceived, submitReceived, deleteReceived, addProductsToBrandReceived, changeByPercentageReceived } = slice.actions;

export default slice.reducer;

export const getAll = data => ({
    types: [requested.type, itemsReceived.type, failed.type],
    url: getApiUrl(name, 'getall'),
    payload: data
});

export const submit = data => ({
    types: [requested.type, submitReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'submit'),
    payload: data
});

export const remove = ids => ({
    types: [requested.type, deleteReceived.type, failed.type],
    method: 'post',
    url: getApiUrl('productbrandprice', 'delete'),
    payload: ids
});

export const addProductsToBrand = data => ({
    types: [requested.type, addProductsToBrandReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'addproductstobrand'),
    payload: data
});

export const changeByPercentage = data => ({
    types: [requested.type, changeByPercentageReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'changebypercentage'),
    payload: data
});